import {
  AlertCircle,
  AlertTriangle,
  ArrowDown,
  ArrowLeft,
  ArrowNarrowDown,
  ArrowNarrowUp,
  ArrowRight,
  ArrowUp,
  BarChart01,
  BarChartSquare03,
  Calendar,
  Camera02,
  CameraOff,
  ChartBreakoutSquare,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronDownDouble,
  ChevronLeft,
  ChevronLeftDouble,
  ChevronRight,
  ChevronRightDouble,
  ChevronSelectorHorizontal,
  ChevronSelectorVertical,
  ChevronUp,
  ChevronUpDouble,
  Circle,
  ClipboardMinus,
  Columns03,
  Copy05,
  DotsVertical,
  Download01,
  Edit05,
  Expand05,
  Eye,
  EyeOff,
  FilePlus02,
  HelpCircle,
  Image01,
  ImageIndentRight,
  ImageRight,
  InfoCircle,
  Key01,
  LockKeyholeSquare,
  LogOut01,
  Mail01,
  Mark,
  MarkerPin02,
  Menu02,
  Minimize02,
  Moon01,
  Package,
  Play,
  Plus,
  RefreshCw05,
  Repeat04,
  Rows03,
  Scan,
  SearchSm,
  Send01,
  Settings01,
  Shield01,
  ShieldPlus,
  ShieldTick,
  Sliders01,
  Sun,
  SwitchHorizontal02,
  SwitchVertical02,
  Tool02,
  Trash01,
  User01,
  Users01,
  XClose,
} from "@untitledui/icons";
import type React from "react";

import MeqLoading from "~/assets/icons/meq-loading.svg?react";
import MeqLogo from "~/assets/icons/meq-logo.svg?react";

const ICONS = {
  AlertCircle,
  AlertTriangle,
  ArrowDown,
  ArrowLeft,
  ArrowNarrowDown,
  ArrowNarrowUp,
  ArrowRight,
  ArrowUp,
  BarChart: BarChart01,
  BarChartSquare: BarChartSquare03,
  Calendar,
  Camera: Camera02,
  CameraOff,
  Check,
  ChartBreakoutSquare,
  CheckCircle,
  ChevronDown,
  ChevronDownDouble,
  ChevronLeft,
  ChevronLeftDouble,
  ChevronRight,
  ChevronRightDouble,
  ChevronSelectorHorizontal,
  ChevronSelectorVertical,
  ChevronUp,
  ChevronUpDouble,
  Circle,
  ClipboardMinus,
  Column: Columns03,
  Copy: Copy05,
  Density: Rows03,
  Download: Download01,
  Edit: Edit05,
  Eye,
  EyeOff,
  FilePlus02,
  Sliders: Sliders01,
  HelpCircle,
  FullScreen: Expand05,
  FullScreenExit: Minimize02,
  InfoOutlined: InfoCircle,
  Image: Image01,
  ImageIndentRight,
  ImageRight,
  Key: Key01,
  LocationMark: Mark,
  LockKeyHole: LockKeyholeSquare,
  Logout: LogOut01,
  Mail: Mail01,
  MarkerPin: MarkerPin02,
  Menu: Menu02,
  MeqLoading,
  MeqLogo,
  Moon: Moon01,
  MoreVert: DotsVertical,
  Package,
  Play,
  Plus,
  Refresh: RefreshCw05,
  Repeat: Repeat04,
  Scan,
  SearchSm,
  Send: Send01,
  Settings: Settings01,
  Shield: Shield01,
  ShieldPlus,
  ShieldTick,
  Sun,
  SwitchHorizontal: SwitchHorizontal02,
  SwitchVertical: SwitchVertical02,
  Tool: Tool02,
  Trash: Trash01,
  User: User01,
  Users: Users01,
  XClose,
} as const;

export type IconName = keyof typeof ICONS;

export type SvgIconRawProps = {
  name: IconName;
  size?: number | string;
  fill?: string;
  color?: string;
  strokeWidth?: number | string;
} & Omit<
  React.SVGProps<SVGSVGElement>,
  "name" | "fill" | "color" | "strokeWidth" | "width" | "height" | "ref"
>;

const SvgIconRaw = ({
  name,
  size = "1em",
  fill = "none",
  color = "currentColor",
  strokeWidth = 2,
  ...rest
}: SvgIconRawProps) => {
  const Icon = ICONS[name];

  if (!Icon) {
    return null;
  }

  return (
    <Icon
      width={size}
      height={size}
      fill={fill}
      stroke={color}
      strokeWidth={strokeWidth}
      {...rest}
    />
  );
};

export default SvgIconRaw;
